module.exports = __webpack_public_path__ + "static/media/437e65ad.jpg";